import React from 'react';
import { Marker, Popup } from 'react-leaflet';
import { createCustomIcon, mapIcons, transformBusPropertiesToData, urgencyColors } from '_helpers'; // Assurez-vous d'avoir une fonction pour créer des icônes
import CustomTooltip from '_components/CustomTooltip';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { vehicleActions } from '_store';

function BusLayer({ bus }) {

    const {pathname } = useLocation(); 
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const level = (bus.properties.URGENCY_LEVEL !== '3' && bus.properties.URGENCY_LEVEL !== '4') ? bus.properties.STATE : (bus.properties.URGENCY_LEVEL ?? '')
    const customIcon = createCustomIcon(mapIcons(level), 'rgba(255, 255, 255, 0.7)', 30);
    
    const handleViewBus = (item) => {
        dispatch(vehicleActions.setVehicle(item));
        navigate(`bus/${item.HEADER_VIN}`)
    }
    
    return (
        <Marker position={bus.geometry.coordinates[0]} icon={customIcon}>
            <Popup className='custom-tooltip'>
                <CustomTooltip                    
                    bg={urgencyColors[level] ?? 'offline'} 
                    data={transformBusPropertiesToData(bus.properties)} 
                    title={`VIN: ${bus.properties.HEADER_VIN}`} 
                    button={pathname === '/donnees' ? {
                        label: "VOIR LE DÉTAIL: BUS",
                        icon: "viewBusWhite", 
                        onClick: () => handleViewBus(bus.properties),
                    } : {}}
                />
            </Popup>
        </Marker>
    );
}

export default BusLayer;
